/*
 * @Author: cai
 * @Date: 2020-12-18 09:12:35
 * @LastEditors: cai
 * @LastEditTime: 2021-04-14 15:21:07
 * @FilePath: \官网\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import axios from 'axios'
import fastClick from 'fastclick'
import '../static/js/rem.js'
// import '../static/css/animate.css'
import animate from 'animate.css'
 
// require styles
import 'swiper/dist/css/swiper.css'
 
Vue.use(VueAwesomeSwiper, /* { default global options } */)

Vue.use(ElementUI)

Vue.config.productionTip = false
var Qs = require('qs')
Vue.prototype.axios = axios
Vue.prototype.qs = Qs.stringify
Vue.config.ignoredElements = ['wx-open-launch-weapp']

axios.defaults.timeout = 6000;
axios.defaults.baseURL = '/steel-admin/'  
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
fastClick.attach(document.body)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js